import { useContextSelector } from "use-context-selector";
import { InfoContext } from "../context/InfoContext";

export const useInfo = () => {
  const telemedicineData = useContextSelector(
    InfoContext,
    (context) => context.telemedicineData
  );

  const handleSetTelemedicineData = useContextSelector(
    InfoContext,
    (context) => context.handleSetTelemedicineData
  );

  const bioDocConfig = useContextSelector(
    InfoContext,
    (context) => context.bioDocConfig
  );

  const handleSetBioDocConfig = useContextSelector(
    InfoContext,
    (context) => context.handleSetBioDocConfig
  );

  return {
    telemedicineData,
    handleSetTelemedicineData,
    bioDocConfig,
    handleSetBioDocConfig,
  };
};
